import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PreferredCategories} from '../../../model/portfolio-preferences.model';
import {ConfirmPopUpSkeletonData} from '../../../comfirm-pop-up/skeleton/confirm-pop-up-skeleton.component';

export interface PortfolioPreferencesConfirmationPopUpData extends ConfirmPopUpSkeletonData {
    preferredCategories: PreferredCategories[];
}

@Component({
    templateUrl: './portfolio-preferences-confirmation-pop-up.component.html'
})
export class PortfolioPreferencesConfirmationPopUpComponent {
    constructor(
        public dialogRef: MatDialogRef<PortfolioPreferencesConfirmationPopUpComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly popUpData: PortfolioPreferencesConfirmationPopUpData) {
    }
}